/**
 * Resolve a theme CSS variable (oklch / color-mix / var()) to an rgba() string —
 * lightweight-charts paints on canvas and only understands plain colour strings.
 * Painting one pixel and reading it back normalises any CSS colour syntax.
 */
export function themeColor(name: string, fallback: string, alpha?: number): string {
	try {
		const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
		if (!raw) return fallback;
		const ctx = document.createElement("canvas").getContext("2d", { willReadFrequently: true });
		if (!ctx) return fallback;
		ctx.clearRect(0, 0, 1, 1);
		ctx.fillStyle = fallback;
		ctx.fillStyle = raw;
		ctx.fillRect(0, 0, 1, 1);
		const [r, g, b, a] = ctx.getImageData(0, 0, 1, 1).data;
		const outA = alpha ?? (a ?? 255) / 255;
		return `rgba(${r}, ${g}, ${b}, ${Number(outA.toFixed(3))})`;
	} catch {
		return fallback;
	}
}
